import { fromClass } from "fw-model";
import { SearchResult } from "./search-result";

export enum AppSyncAction {
    Synchronize,
    Remove
}

export enum FilterKeys {
    selectedOrganization,
    selectedEnvironment
}

export enum AppSyncDetailsTabs {
    GeneralInformation,
    History,
    AtsMissingApps,
    CasMissingApps,
    DeliveredApps,
    DeliveredDocs
}

export enum AGGREGATION_MAPPING {
    "allVerified",
    "sum_verifiedDocs",
    "totalInSync",
    "withAtsMissingApps",
    "withCasMissingApps",
    "sum_deliveredApps",
    "sum_deliveredDocs"
}

export enum DOCUMENT_STATUS {
    None = 0,
    Verified = 1,
    Delivered = 2
}

export enum REASON_TYPE {
    None = 0,
    Other = 1,
    MissingFromCas = 2,
    MissingFromAts = 3
}

export type AppSyncFilter = {
    casEnvironment?: string;
    organization?: string;
    isLatest?: boolean;
    status?: number;
    search?: string;
    appSyncResultId?: string;
    tabType?: AppSyncDetailsTabs;
};

export type HistoryFilter = {
    isLatest?: boolean;
    status?: number;
    search?: string;
    appSyncResultId?: string;
    range?: string | [];
};

export type StatusAggregationItem = {
    Key: number;
    Total: number;
};

export class AppSyncInfoField {
    Label: string;
    Key: string;
    Handler?: Function;
    CanCopy?: boolean;
}

export class AppSyncDetailMetadata {
    DateCreatedUtc: Date;
    DateUpdatedUtc: Date;
}

export class AppSyncResultMetaData {
    AtsOrganizationName: string;
    DateCreatedUtc: Date;
    DateUpdatedUtc: Date;
    AtsOrganizationId: string;
    AtsSeasonId: string;
}

export class AppSyncDetail {
    Id: string;
    CasProgramId: string;
    CasApplicationId: string;
    GivenName: string;
    FamilyName: string;
    AppSyncResultId: string;
    AppSyncAction: AppSyncAction;
    Documents: AppDocument[];
    ReasonType: REASON_TYPE;
    ReasonDescription: string;
    IsDelivered: boolean;
    @fromClass MetaData: AppSyncDetailMetadata;
}

export class AppDocument {
    Name: string;
    Status: DOCUMENT_STATUS;
}

export class AppSyncInfo {
    AtsApplicantCount: number;
    AtsMissingApps: number;
    CasApplicantCount: number;
    CasApplicationFormId: string;
    CasMissingApps: number;
    CasOrganizationId: string;
    CasOrganizationName: string;
    CasEnvironment: string;
    DeliveredApps: number;
    DeliveredDocs: number;
    Duration: number; // in milliseconds
    Id: string;
    IsLatest: boolean;
    MissingProgramsCount: number;
    ProgramsCount: number;
    SyncStartedUtc: Date;
    VerifiedDocs: number;
    QueuedCount: number;
    CompletedCount: number;
    @fromClass MetaData: AppSyncResultMetaData;
}

export class AppSyncSearchInfo extends SearchResult<AppSyncInfo> {}
export class AppSyncSearchDetails extends SearchResult<AppSyncDetail> {}
